var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "meeting-agenda__items-container" },
    _vm._l(_vm.agendaItems, function(item, index) {
      return _c("AgendaItem", {
        key: "notes-" + index,
        attrs: { item: item, index: index }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }